import { render } from "./MyVouchersByMerchantPage.vue?vue&type=template&id=2679721d&scoped=true"
import script from "./MyVouchersByMerchantPage.vue?vue&type=script&lang=js"
export * from "./MyVouchersByMerchantPage.vue?vue&type=script&lang=js"

import "./MyVouchersByMerchantPage.vue?vue&type=style&index=0&id=2679721d&scoped=true&lang=css"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2679721d"]])

export default __exports__